import { GraphicsUtil } from "../../util/view/GraphicsUtil";
import { ViewUtils } from "../../util/view/ViewUtils";
import { ResizeEvent } from "../renderer/Renderer";
import { AbstractControl } from "./AbstractControl";
/*
 * TitanPanel.ts
 */
export class TitanPanel extends AbstractControl {
    static createPanel(parent, name, properties, portraitProperties) {
        let panel;
        if (properties) {
            panel = new TitanPanel(properties, portraitProperties);
            if (name) {
                panel.name = name;
            }
            if (panel && parent) {
                parent.addChild(panel);
            }
        }
        return panel;
    }
    createProperties(properties, portraitProperties) {
        super.createProperties(properties, portraitProperties);
        this.responsive = true;
        this.landscapeProperties = properties;
        this.portraitProperties = portraitProperties;
        this.uiProperties = this.uiProperties;
    }
    create() {
        this.resetChildren();
        this.container = ViewUtils.createContainer(this, "panelContainer");
        this.createMasks();
        this.createLayout(this.uiProperties);
    }
    destroy() {
        super.destroy();
        this.panelChildren.forEach(child => {
            this.layout.removeChild(child);
            child.destroy();
        });
        this.panelChildren = null;
        this.container.destroy();
        this.container = null;
        this.landscapeMask && this.landscapeMask.destroy();
        this.landscapeMask = null;
        this.portraitMask && this.portraitMask.destroy();
        this.portraitMask = null;
        this.layout = null;
    }
    addEventListeners() {
        super.addEventListeners();
        this.registerCore(ResizeEvent.POST_ROTATE, this.handlePostRotate);
    }
    resetChildren() {
        this.panelChildren = [];
    }
    createMasks() {
        if (this.landscapeProperties.size) {
            this.landscapeMask = this.createRectangle(this.landscapeProperties);
        }
        if (this.portraitProperties?.size) {
            this.portraitMask = this.createRectangle(this.portraitProperties);
        }
    }
    createRectangle(properties) {
        let graphics = GraphicsUtil.createMask(properties.size);
        graphics.name = "symbolsMask";
        this.container.addChild(graphics);
        return graphics;
    }
    createLayout(properties) {
        this.layout = properties.layout.clone();
        this.layout.setPanel(this);
    }
    unhighlightButtons() {
        this.layout?.getHolder()?.children.forEach((child) => {
            if (child.forceUnpressedState instanceof Function) {
                child.forceUnpressedState();
            }
        });
    }
    arrange() {
        this.layout.apply(this.panelChildren);
    }
    removeAll() {
        while (this.panelChildren.length > 0) {
            this.removeFromPanel(this.panelChildren[0], false);
        }
        this.arrange();
        this.resetChildren();
    }
    addToPanelAt(child, addAtIndex, arrangePanel) {
        let index = this.childIndex(child);
        if (index < 0) {
            this.panelChildren.splice(addAtIndex, 0, child);
            if (arrangePanel) {
                this.arrange();
            }
        }
    }
    addToPanel(child, arrangePanel) {
        let index = this.childIndex(child);
        if (index < 0) {
            this.panelChildren.push(child);
            if (arrangePanel) {
                this.arrange();
            }
        }
    }
    removeFromPanel(child, arrangePanel) {
        let index = this.childIndex(child);
        if (index >= 0) {
            this.panelChildren.splice(index, 1);
            this.layout.removeChild(child);
            if (arrangePanel) {
                this.arrange();
            }
        }
    }
    updateLayout(layout) {
        this.layout = layout.clone();
        this.layout.setPanel(this);
    }
    removeFromPanelAt(index, arrangePanel) {
        this.removeFromPanel(this.panelChildren[index], arrangePanel);
    }
    getPanelChildAt(index) {
        return this.panelChildren[index];
    }
    childIndex(child) {
        return this.panelChildren.indexOf(child);
    }
    getChildren() {
        return this.panelChildren;
    }
    getTotalChildren() {
        return this.panelChildren.length;
    }
    getContainer() {
        return this.container;
    }
    getProperties() {
        return this.uiProperties;
    }
    getSize() {
        return this.layout.getSize();
    }
    bringChildToFront(child) {
        if (this.panelChildren.indexOf(child) > -1) {
            this.layout.getHolder().addChild(child);
        }
    }
    sendChildToBack(child) {
        if (this.panelChildren.indexOf(child) > -1) {
            this.layout.getHolder().addChildAt(child, 0);
        }
    }
    handleResize(event) {
        super.handleResize(event);
        this.arrange();
    }
    handleRotate(event) {
        super.handleRotate(event);
        this.uiProperties = this.uiProperties;
        this.container.removeChildren();
        const data = event?.getCurrentTarget() || {};
        if (this.uiProperties.useMask) {
            if (this.renderer.isPortrait(data.forceOrientation) && this.hasPortraitProperties) {
                this.container.removeChild(this.landscapeMask);
                this.container.addChild(this.portraitMask);
                this.container.mask = this.portraitMask;
            }
            else {
                this.container.removeChild(this.portraitMask);
                this.container.addChild(this.landscapeMask);
                this.container.mask = this.landscapeMask;
            }
        }
        this.createLayout(this.uiProperties);
    }
    handlePostRotate() {
        if (this.running) {
            this.arrange();
        }
    }
}
//# sourceMappingURL=TitanPanel.js.map